module.exports = __webpack_public_path__ + "account/assets/tabs-card-play.4886bbf6.svg";